<template>
  <b-card
    class="not-found-card"
    body-class="d-flex justify-content-center align-items-center"
  >
    <div>
      <div class="d-flex justify-content-center align-items-center">
        <feather-icon icon="AlertCircleIcon" size="80" stroke="#ea5455" />
      </div>
      <div class="text-center mt-2">
        <span class="d-block text-uppercase text-semibold-black">
          No Site Access Request Not Found!
        </span>
        <span class="d-block text-color-grey custom-margin-top-8">
          Please contact your organization admin
        </span>
      </div>
      <div class="redirect-timer">
        <div class="d-flex justify-content-center">
          <span class="text-color-grey text-size-12">
            Return to Homepage Automatically in
            <span class="text-color-black">{{ redirectTime }}</span>
          </span>
        </div>
        <div class="d-flex justify-content-center">
          <atom-button
            buttonId="close-btn"
            class="close-btn-width mt-1"
            @click="clickCloseButton"
          >
            Close
          </atom-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
export default {
  name: "MoleculeNotFoundCard",
  components: {
    BCard,
    AtomButton,
  },
  props: {
    redirectTime: {
      type: Number,
      required: true,
    },
  },
  emits: ["onClickClose"],

  methods: {
    clickCloseButton() {
      this.$emit("onClickClose")
    },
  },
}
</script>

<style lang="scss" scoped>
.not-found-card {
  position: relative;
  height: 525px;
  width: 600px;
}

.redirect-timer {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

.close-btn-width {
  width: 285px;
}
</style>
